'use strict';

const ItemPickerDirective=require('../itemPickerDirective/itemPickerDirective');let

WeekIntervalPickerDirective=class WeekIntervalPickerDirective extends ItemPickerDirective{
get templateUrl(){return'/templates/directives/weekIntervalPickerDirective/weekIntervalPickerTemplate'}};


module.exports=WeekIntervalPickerDirective;
//# sourceMappingURL=weekIntervalPickerDirective.js.map
